import React from 'react';

const TableHeader = React.memo(({headerOptions}) => (
    <thead className="text-xs text-gray-100 uppercase bg-gray-800">
        <tr>
            {headerOptions.map((title, index) => (
                <th key={index} scope="col" className="px-6 py-3">
                    {title}
                </th>
            ))}
        </tr>
    </thead>
));

export default TableHeader;